export const AIAppIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <g clipPath="url(#clip0_12174_9240)">
        <path
          d="M13.9997 15V13.5H14.7497V8.25H13.9997V6.75H16.9997V8.25H16.2497V13.5H16.9997V15H13.9997ZM11.3747 15H12.8747L10.2497 6.75H7.9997L5.37695 15H6.87695L7.3277 13.5H10.9112L11.3747 15ZM7.7792 12L9.0002 7.94175L9.1922 7.9395L10.4477 12H7.7792ZM20.1625 15.75L18.8222 18.4657L15.8252 18.9008L17.9942 21.0157L17.482 24L20.1625 22.5907L22.843 24L22.3307 21.015L24.4997 18.9015L21.5027 18.4657L20.1625 15.75Z"
          fill="black"
        />
        <path
          d="M13.25 22.5H0.5V0H23V12.75H21.5V1.5H2V21H13.25V22.5Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_12174_9240">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
